const ContractQuote = ({ text }) => {
  return (
    <div
      style={{
        fontSize: "0.9rem",
        lineHeight: "1.4",
        color: "#333",
        marginBottom: "12px",
      }}
    >
      <p style={{ margin: 0, fontStyle: "italic" }}>“{text}”</p>
    </div>
  )
}

export default ContractQuote
